import httpGoodNewsService from './httpGoodNewsService';

const goodNewsService = {
    getGoodNews: (params) => {
        return httpGoodNewsService.get('/', { params });
    },
};

export default goodNewsService;
